import { createSlice } from "@reduxjs/toolkit";
import { fetchChatBotResponse } from "../../thunks/common-thunks/commonThunk";
import { message } from "antd";

const initialState = {
  isLoading: false,
  error: null,
  response: null,
};

export const chatBotSlice = createSlice({
  name: "chatBot",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatBotResponse.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchChatBotResponse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload.response;
      })
      .addCase(fetchChatBotResponse.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default chatBotSlice.reducer;
